import { Icon } from '@/components/Icon'
import { type IconNames } from '@/components/Icon/Icons'
import { storeConsent, loadPrivacyManager } from '@/libs/consent/consent'
import { SocialVendor } from '@/types/consent'
import styles from './EmbedSocial.module.scss'
import { RequestCookie } from 'next/dist/compiled/@edge-runtime/cookies'

const NoConsent = ({
  type,
  purMode,
  setForceShowEmbed,
  cookies,
}: {
  type: string
  purMode: boolean
  setForceShowEmbed: (show: boolean) => void
  cookies: RequestCookie[]
}) => {
  type SocialMap = {
    [key: string]: {
      name: string
      vendor: SocialVendor
      icon: IconNames
    }
  }

  const socialMap: SocialMap = {
    facebookpost: {
      name: 'Facebook',
      vendor: 'facebook',
      icon: 'facebookColor',
    },
    facebookvideo: {
      name: 'Facebook',
      vendor: 'facebook',
      icon: 'facebookColor',
    },
    instagram: {
      name: 'Instagram',
      vendor: 'instagram',
      icon: 'instagramColor',
    },
    instagram_2: {
      name: 'Instagram',
      vendor: 'instagram',
      icon: 'instagramColor',
    },
    tiktok: {
      name: 'TikTok',
      vendor: 'tiktok',
      icon: 'tiktokColor',
    },
    twitter: {
      name: 'X',
      vendor: 'x',
      icon: 'x',
    },
    youtube: {
      name: 'YouTube',
      vendor: 'youtube',
      icon: 'youtubeColor',
    },
  }

  const setConsent = () => {
    setForceShowEmbed(true)
    storeConsent(cookies, socialMap[type].vendor)
  }

  const callPrivacyManager = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault()
    loadPrivacyManager()
  }

  const name = socialMap[type] ? socialMap[type].name : ''

  return (
    <div className={styles.noconsent}>
      <Icon name={socialMap[type].icon} />
      <strong>Empfohlener Inhalt</strong>
      {!purMode && (
        <p>
          Aufgrund Ihrer Privacy Einstellungen können wir an dieser Stelle keinen Inhalt der externen Plattform {name}{' '}
          anzeigen. Sie können sich den Inhalt mit einem Click wieder anzeigen lassen und im{' '}
          <a href="https://www.n-tv.de/15745191" onClick={(event) => callPrivacyManager(event)}>
            Privacy Center
          </a>{' '}
          weitere Einstellungen anpassen.
        </p>
      )}
      {purMode && (
        <p>
          Auf Grund ihrer Privatsphären-Einstellungen können wir an dieser Stelle keine Inhalt der externen Plattform{' '}
          {name} anzeigen. Um diesen (und weitere) Inhalt(e) für Ihre laufende Sitzung anzuzeigen, klicken Sie bitte auf
          &quot;Inhalte von {name} anzeigen&quot;. Ihre Zustimmung wird bis zum Schließen des Browsers mit einem Cookie
          gespeichert und danach verworfen. Im Falle einer Zustimmung erfolgt evtl. ein Datentransfer und eine
          Datenverarbeitung außerhalb des EWR (Art. 49 (1) (a) DSGVO, Drittlandtransfer), wo das hohe europäische
          Datenschutzniveau nicht besteht. Sie stimmen diesem Drittlandtransfer ebenfalls zu.
        </p>
      )}
      <button className="button secondary" onClick={() => setConsent()}>
        Inhalt von {name} anzeigen
      </button>
    </div>
  )
}

export default NoConsent
